// utils/initialValues.ts
import { FormValues } from "../types";

export const getInitialValues = (): FormValues => ({
  name: "",
  description: "",
  image: [],
  video: "",
  category: "",
  subCategory: [],
  brand: "",
  unit: "",
  foodType: "",
  tags: [],
  price: "",
  discountType: "",
  discount: "",
  popular: false,
  addons: [],
  variants: [],
  stockType: "",
  itemStock: "",
  availableDuringOpening: "1",
  availableTimeStart: "",
  availableTimeEnd: "",
  discountAvailabilty: "1",
  discountstartdate: "",
  discountenddate: "",
  purchaseLimit: "15",
  note: "",
  title: "",
  keyword: "",
  descriptionMeta: "",
  og: null,
  mostorder: false,
  latestarrival: false,
  productSKU: "",
  estimatedDeliveryDay: "",
  deliveryAvailability: "",
  vehicleAvailability: "",
  maxTwoWheelerLimit: "",
  maxFourWheelerLimit: "",
  showInApp: true,
  prescriptionRequired: false,
  useQueue: false,
});

export const transformProductData = (
  productData: any,
  bucketUrl?: string,
): FormValues => {
  return {
    name: productData.name || "",
    description: productData.description || "",
    image: productData.images
      ? productData.images.map((img: any) => ({
          id: img.id,
          image: bucketUrl ? `${bucketUrl}/${img.image}` : img.image,
          rawFile: null,
        }))
      : [],
    video: productData.video || "",
    category: productData?.category?.id || "",
    subCategory:
      productData?.subCategories?.length > 0
        ? productData.subCategories.map((sc: any) => sc.id || sc.subCategoryId)
        : productData?.subCategory?.length > 0
          ? productData.subCategory.map((sc: any) => sc.id || sc.subCategoryId)
          : productData?.subCategory?.id
            ? [productData.subCategory.id]
            : [],
    brand: productData.brand?.id || "",
    unit: productData?.unit || "",
    foodType: productData.type || "veg",
    tags: productData.seoInfos?.tags || [],
    price: productData.price?.toString() || "",
    discountType: productData.discountInfos?.type === "percentage" ? "1" : "2",
    discount: productData.discountInfos?.discount || "",
    popular: productData.isPopular || false,
    addons: productData.addons || [],

    variants: productData.variations
      ? productData.variations.map((variation: any) => ({
          id: variation.id,
          name: variation.color?.name || "",
          code: variation.color?.code || "",
          attributes: variation.attributes
            ? Object.keys(variation.attributes).reduce((acc: any, key) => {
                const val = variation.attributes[key];
                acc[key.trim()] = typeof val === "string" ? val.trim() : val;
                return acc;
              }, {})
            : {},
          price: variation.price?.toString() || "",
          stock: variation.stock?.toString() || "",
          sku: variation.sku || "",
          image: variation.image
            ? {
                id: variation.id,
                image: variation.image,
                rawFile: null,
              }
            : null,
          discountType: variation.discountType || "",
          discount: variation.discount?.toString() || "",
        }))
      : [],
    stockType: productData.stockInfos?.type || "",
    itemStock: productData.stockInfos?.stock || "",
    availableDuringOpening:
      productData.stockInfos?.availability === "opening" ? "1" : "2",
    availableTimeStart: productData.stockInfos?.startTime || "",
    availableTimeEnd: productData.stockInfos?.endTime || "",
    discountAvailabilty:
      productData.discountInfos?.availability === "always" ? "1" : "2",
    discountstartdate: productData.discountInfos?.startDate || "",
    discountenddate: productData.discountInfos?.endDate || "",
    purchaseLimit: productData.stockInfos?.maxPurchaseLimit || "15",
    note: productData.requiredNotes || "Text",
    title: productData.seoInfos?.title || "",
    keyword: productData.seoInfos?.keywords || "",
    descriptionMeta: productData.seoInfos?.description || "",
    og: productData?.seoInfos?.ogImage || null,
    mostorder: productData.isMostOrdered || false,
    latestarrival: productData.isLatestArrival || false,
    productSKU: productData.sku || "",
    estimatedDeliveryDay: productData.estimatedDeliveryDay?.toString() || "",
    deliveryAvailability: productData.deliveryAvailability || "",
    vehicleAvailability: productData.vehicleAvailabilty || "",
    maxTwoWheelerLimit: productData.twoWheelerLimit || "",
    maxFourWheelerLimit: productData.fourWheelerLimit || "",
    showInApp: productData.showInApp ?? true,
    prescriptionRequired: productData.prescriptionRequired || false,
  };
};
